import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  getNotificationMessage,
  markersSelectors,
  setProfileItemId,
  showCurrentChatFriendMarkerCoordinate,
  singleMarkerUpdate,
  usersSelectors
} from 'store'
import { REJECTED } from 'utils/constants'

export const useGoToProfileMarker = () => {
  const dispatch = useDispatch()

  const {
    filters,
    userProfile
  } = useSelector(usersSelectors)
  const { markers } = useSelector(markersSelectors)

  const handleFiltersInfo = () => {
    let codewordFilterCount = 0
    let affinityFilterCount = 0
    let ownFilterCount = 0
    let filterAffinityList = []

    filters?.forEach((f) => {
      if (f?.type === 'affinities') {
        affinityFilterCount += 1
        filterAffinityList.push(f?.title)
      } else if (f?.type === 'code_word') {
        codewordFilterCount += 1
      } else {
        ownFilterCount += 1
      }
    })

    return {
      codewordFilterCount,
      affinityFilterCount,
      ownFilterCount,
      filterAffinityList
    }
  }

  const goToProfileMarker = async (
    profileId,
    coordinates
  ) => {
    let result = []
    result = await dispatch(singleMarkerUpdate(profileId))

    if (
      markers.find((marker) => marker.id === profileId)
      || userProfile.find((profile) => profile.id === profileId)
      || result?.payload?.length
    ) {
      const filtersInfo = handleFiltersInfo()
      let affinityMatchCount = 0

      if (
        !filtersInfo.ownFilterCount
        && !filtersInfo.codewordFilterCount
        && filtersInfo.affinityFilterCount
      ) {
        result?.payload[0]?.affinities.forEach((profileAffi) => {
          if (filtersInfo.filterAffinityList.includes(profileAffi)) {
            affinityMatchCount += 1
          }
        })
      }

      if (
        !filtersInfo.ownFilterCount
        && !filtersInfo.codewordFilterCount
        && filtersInfo.affinityFilterCount === affinityMatchCount
      ) {
        const backBtn = document.querySelector('#back-button')
        backBtn?.click()
        dispatch(setProfileItemId(''))

        setTimeout(() => {
          dispatch(showCurrentChatFriendMarkerCoordinate({
            coord: coordinates,
            isStatic: true
          }))

          sessionStorage.setItem('openProfileAfterAnimation', profileId)
        }, backBtn ? 1050 : 0)
      } else {
        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'The marker filter hides this profile',
            isEditProfile: false
          })
        )
      }
    }
  }

  return goToProfileMarker
}
